import React from 'react';
import PropTypes from 'prop-types';

const TravellingPastUniqueVsRepeat = props => (
  <div>
    <div className="TravellingPastUniqueVsRepeat">
      {props.clientId === '5c582f6bf49491ca3dd9afac' ||
      props.clientId === '5e37ad437aa63c7bd54a516e' ||
      props.clientId === '5eaa2dfafbe9930f0516c1f4' ? (
        <React.Fragment>
          <div className="TravellingPastUniqueVsRepeat_section">
            <span className="TravellingPastUniqueVsRepeat_percentage">
              {Number.isNaN(props.repeatPercent)
                ? 0
                : Math.round(props.repeatPercent)}
              %
            </span>
            <span className="TravellingPastUniqueVsRepeat_title">
              the percentage of devices that travel past the selected Point(s)
              of Interest more than once
            </span>
          </div>
          <div className="TravellingPastUniqueVsRepeat_section">
            <span className="TravellingPastUniqueVsRepeat_percentage">
              {Number.isNaN(props.uniquePercent)
                ? 0
                : Math.round(props.uniquePercent)}
              %
            </span>
            <span className="TravellingPastUniqueVsRepeat_title">
              the percentage of devices that travel past the selected Point(s)
              of Interest only once
            </span>
          </div>
        </React.Fragment>
      ) : (
        <span
          className="TravellingPastUniqueVsRepeat_title"
          style={{ marginBottom: '100px' }}
        >
          Insights coming soon
        </span>
      )}
    </div>

    {props.clientId === '5e65c56daea1a93aa7211595' ? (
      <div />
    ) : (
      <React.Fragment>
        <h3 className="content-card_title">Age & Gender</h3>
        <div className="TravellingPastUniqueVsRepeat">
          <div className="TravellingPastUniqueVsRepeat_frequency">
            <span className="TravellingPastUniqueVsRepeat_title">
              Insights coming soon
            </span>
          </div>
        </div>
      </React.Fragment>
    )}
  </div>
);

TravellingPastUniqueVsRepeat.propTypes = {
  repeatPercent: PropTypes.number,
  uniquePercent: PropTypes.number,
  averageEvents: PropTypes.number,
  averageEventsByPOI: PropTypes.number,
};

TravellingPastUniqueVsRepeat.defaultProps = {
  repeatPercent: undefined,
  uniquePercent: undefined,
  averageEvents: undefined,
  averageEventsByPOI: undefined,
};

export default TravellingPastUniqueVsRepeat;
